import {request} from "../shared/httpInterceptor";
import {useCountryLang} from "./useCountryLang";
import {useQuery} from '@tanstack/react-query';
import {ICompanyInit} from "../interfaces/ICompanyInit";

export const fetchCompanyInit = async (countryLang: string | null, host?: string) => {
  const res = await request({
    url: `/${countryLang}/register/company/init`,
    method: 'get',
    host: host
  });
  return res.data;
}

const useCompanyInit = () => {
  const countryLang = useCountryLang()
  return useQuery<ICompanyInit>(["company-init", countryLang], () => fetchCompanyInit(countryLang), {
    enabled: countryLang != null
  });
}

export default useCompanyInit;